import axios from 'axios';
import baseService from '../shared/baseService';
import { NewsStatus } from '../Features/Classification/enum/NewsStatus';

const newsService = (spreadsheetId: number) => 
    baseService(`spreadsheets/${spreadsheetId}/news`);

const updateStatusNews = (spreadsheetId: number, newsId: number, status: NewsStatus) => 
    axios.patch(`/spreadsheets/${spreadsheetId}/news/${newsId}`, { status: status });

const updatePendingNews = (spreadsheetId: number, status: NewsStatus) => 
    axios.patch(`/spreadsheets/${spreadsheetId}/news/`, { status: status });

const getAll = (spreadsheetId: number, status: NewsStatus) =>
    axios.get(`/spreadsheets/${spreadsheetId}/news?classificationStatus=${status}`);

export default { 
    newsService,
    updateStatusNews,
    updatePendingNews,
    getAll
};